import { Partial } from '@40seas/entities/common';
import { CurrencyConversion } from './currency-conversion.entity';

export class UpdateCurrencyConversion extends Partial(CurrencyConversion) {}
